export const DEFAULT_LANG = "ca";
export const SUPPORTED_LANGS = ["ca", "es", "en"];
